// N.b. All "month" parameters should be strings in the format "YYYY-M"
export function parseISODateOnlyToLocal(s: string): Date {
  const b = s.split(/\D/);
  return new Date(parseInt(b[0]), parseInt(b[1]) - 1, parseInt(b[2]));
}

function toUTCDate(date: undefined | null): undefined;
function toUTCDate(date: Date | string): Date;
function toUTCDate(date: Date | string | undefined | null): Date | undefined {
  if (!date) return undefined;
  if (typeof date === "string") date = new Date(date);

  return new Date(
    Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      0,
      0
    )
  );
}

export type FormatDateFormat = {
  day?: "numeric" | "2-digit";
  weekday?: "long" | "short" | "narrow";
  month?: "long" | "short" | "narrow";
  year?: "numeric" | "2-digit";
};

function formatDate(
  date: undefined,
  language: string,
  format: FormatDateFormat
): string;
function formatDate(
  date: Date | string,
  language: string,
  format: FormatDateFormat
): string;
function formatDate(
  date: Date | string | undefined,
  language: string,
  format: FormatDateFormat
): string {
  if (!date) return "";
  const dateFormat = { ...format, timeZone: "UTC" };

  const utcDate = toUTCDate(date);

  if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined")
    return utcDate.toLocaleDateString(language, format);

  return new Intl.DateTimeFormat(language, dateFormat).format(utcDate);
}

export { toUTCDate, formatDate };
